/* tslint:disable */
/* eslint-disable */
/**
 * Remaster API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import type { ApiError } from './ApiError'
import { ApiErrorFromJSON, ApiErrorFromJSONTyped, ApiErrorToJSON } from './ApiError'
import type { CategoryDetailUser } from './CategoryDetailUser'
import {
  CategoryDetailUserFromJSON,
  CategoryDetailUserFromJSONTyped,
  CategoryDetailUserToJSON,
} from './CategoryDetailUser'

/**
 *
 * @export
 * @interface EnvelopedCategoryCategoryDetailUser
 */
export interface EnvelopedCategoryCategoryDetailUser {
  /**
   *
   * @type {CategoryDetailUser}
   * @memberof EnvelopedCategoryCategoryDetailUser
   */
  body: CategoryDetailUser
  /**
   *
   * @type {Array<ApiError>}
   * @memberof EnvelopedCategoryCategoryDetailUser
   */
  errors: Array<ApiError>
}

/**
 * Check if a given object implements the EnvelopedCategoryCategoryDetailUser interface.
 */
export function instanceOfEnvelopedCategoryCategoryDetailUser(value: object): boolean {
  let isInstance = true
  isInstance = isInstance && 'body' in value
  isInstance = isInstance && 'errors' in value

  return isInstance
}

export function EnvelopedCategoryCategoryDetailUserFromJSON(
  json: any,
): EnvelopedCategoryCategoryDetailUser {
  return EnvelopedCategoryCategoryDetailUserFromJSONTyped(json, false)
}

export function EnvelopedCategoryCategoryDetailUserFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): EnvelopedCategoryCategoryDetailUser {
  if (json === undefined || json === null) {
    return json
  }
  return {
    body: CategoryDetailUserFromJSON(json['body']),
    errors: (json['errors'] as Array<any>).map(ApiErrorFromJSON),
  }
}

export function EnvelopedCategoryCategoryDetailUserToJSON(
  value?: EnvelopedCategoryCategoryDetailUser | null,
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    body: CategoryDetailUserToJSON(value.body),
    errors: (value.errors as Array<any>).map(ApiErrorToJSON),
  }
}
